import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type SecondaryCategoryConfigConstructor,
  SecondaryCategoryConfig,
} from './SecondaryCategoryConfig'

export const SecondaryCategoryConfigConstructorFactory =
  Factory.Sync.makeFactory<SecondaryCategoryConfigConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.commerce.department()),
    externalId: Factory.each(() => faker.random.alphaNumeric(10)),
    punchoutEmail: Factory.each(() => faker.internet.email()),
  })

export const SecondaryCategoryConfigFactory = EntityFactory(
  SecondaryCategoryConfig,
  SecondaryCategoryConfigConstructorFactory
)
